<app-pias-layout>
  <div pias-layout-content>
    <br />
    <div id="quicklink-container" class="container-fluid">
      <div class="container-fluid Link-card">
        <div class="row">
          <p class="header">Quick Links</p>
          <!-- COLUMN 1 -->
          <div class="col-lg-3 col-md-6 mb-4 mega-col">
            <h6 class="mb-3 mega-title">PIAS Portal</h6>
            <ul class="list-unstyled mega-links">
              <li>
                <a href="https://pias.sg/privilege-card.html" target="_blank">PIAS Premier Client Privilege</a>
              </li>
              <li>
                <a href="https://gi.proinvest.com.sg/login" target="_blank">PIAS Instant Gi Compare Tool</a>
              </li>
              <li>
                <a href="https://singlife.my.site.com/LMS/s/login/" target="_blank">PIAS Salesforce Leads Management
                  System</a>
              </li>
              <li><a href="https://iam.singlife.com/" target="_blank">PIAS eFNA</a></li>
              <li>
                <a href="https://lms.wizlearn.com/pias/Login/Login_pias.aspx?returnUrl=/pias/" target="_blank">PIAS Wizlearn
                  e-learning</a>
              </li>
              <!-- <li>
                <a href="https://iam.singlife.com/app/singlife-adviser_vueprod_1/exk3fg20oqeSKKcGW3l7/sso/saml"
                  target="_blank">VUE Producer Portal</a>
              </li> -->
              <li>
                <a href="https://docushare.proinvest.com.sg/docushare/dsweb/HomePage" target="_blank">DocuShare</a>
              </li>
              <!-- <li>
                <a href="https://www.proinvest.com.sg/our-services/clientprivileges-partners" target="_blank">PIAS
                  Premier Client Privilege</a>
              </li> -->
            </ul>
          </div>

          <!-- COLUMN 2 -->
          <div class="col-lg-5 col-md-6 mb-4 mega-col">
            <h6 class="mb-3 mega-title">Life & Investment</h6>

            <div class="row">
              <div class="col-6">
                <ul class="list-unstyled mega-links">
                  <li><a href="https://iam.singlife.com/" target="_blank">PIAS eFNA</a></li>
                  <li>
                    <a href="https://ezsub.singlife.com/web/login/" target="_blank">Singlife EzSub</a>
                  </li>
                  <li>
                    <a href="https://applogin.singlife.com/SQS/login/" target="_blank">Singlife Pocket SQS Quotation</a>
                  </li>
                  <li>
                    <a href="https://applogin.singlife.com/adviser/#/login" target="_blank">Singlife Online Portal</a>
                  </li>
                  <li>
                    <a href="https://tlbconnect.transamericalifebermuda.com/" target="_blank">Transamerica
                      TLBconnect</a>
                  </li>
                  <li>
                    <a href="https://tmwise.tokiomarine-life.sg/" target="_blank">Tokio Marine TM WISE</a>
                  </li>
                  <li>
                    <a href="https://tmconnect.tokiomarine-life.sg/" target="_blank" rel="noopener">Tokio Marine TM
                      Connect</a>
                  </li>
                  <li>
                    <a href="https://partner-dashboard.getcare.io/insurance" target="_blank" rel="noopener">Raffles
                      Health Insurance- Agent Login</a>
                  </li>
                  <li>
                    <a href="https://www.tigerbrokers.com.sg/acct/auth/login?next=%2F" target="_blank"
                      rel="noopener">Tiger brokers (Singapore)</a>
                  </li>
                   <li>
                    <a href="https://www.insurance.hsbc.com.sg/help/agents/" target="_blank"
                      rel="noopener">HSBC Life</a>
                  </li>
                </ul>
              </div>

              <div class="col-6">
                <ul class="list-unstyled mega-links">
                  <li>
                    <a href="https://www.fwd.com.sg/iSmartWeb/home/client-profile" target="_blank">FWD SMART</a>
                  </li>
                  <li><a href="https://incsso.income.com.sg/" target="_blank">Income eApp</a></li>
                  <li>
                    <a href="https://fa.manuview.sg/bis/aws_main_partner.jsp" target="_blank">Manulife Manuview</a>
                  </li>
                  <li><a href="https://api.emmprd.asia.manulife.com/ext/pos-web-app-sgp/mcf_redirect" target="_blank">Manulife M360</a></li>
                  <li>
                    <a href="https://ispeed.cntaiping.sg/ui/ipad-main/#/pages/login/index" target="_blank">China Taiping
                      iSpeed</a>
                  </li>
                  <li>
                    <a href="https://www.etiqa.com.sg/iConnect/Agent/Login" target="_blank">eTiQa iConnect</a>
                  </li>
                  <li>
                    <a href="https://secure.ifastnetwork.com/ifa/adviser/login" target="_blank" rel="noopener">iFAST
                      Central</a>
                  </li>
                  <li>
                    <a href="https://secure.ifastgp.com/ifastgp/adviser/login" target="_blank" rel="noopener">iFAST
                      Global Prestige (IGP)</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- COLUMN 3 -->
          <div class="col-lg-4 col-md-12 mb-4 mega-col">
            <h6 class="mb-3 mega-title">GI</h6>

            <div class="row">
              <div class="col-6">
                <ul class="list-unstyled mega-links">
                  <li>
                    <a href="https://applogin.singlife.com/adviser/#/login" target="_blank">Singlife Online Portal</a>
                  </li>
                  <li>
                    <a href="https://tmonline.tokiomarine.com.sg/aic/login/login.jsp" target="_blank">Tokio Marine Gi-TM
                      Online</a>
                  </li>
                  <li>
                    <a href="https://singapore.merimen.com/epolicy/?lf=EPLRSASG" target="_blank">Allied World
                      Merimen</a>
                  </li>
                  <li>
                    <a href="https://my-aw-portal.alliedworld.cloud/user/login" target="_blank">Allied World
                      Pricelink</a>
                  </li>
                  <li><a href="https://www.ichannel.com.sg/" target="_blank">Sompo iChannel</a></li>
                  <li>
                    <a href="https://azconnect.allianz.sg/intermediaries/#/" target="_blank">Allianz</a>
                  </li>
                  <li>
                    <a href="https://qnect.qbe.com/sg/" target="_blank" rel="noopener">QBE QNECT</a>
                  </li>
                  <li>
                    <a href="https://hub2.apac.chubb.com/" target="_blank" rel="noopener">Chubb Producer Hub</a>
                  </li>
                </ul>
              </div>

              <div class="col-6">
                <ul class="list-unstyled mega-links">
                  <li>
                    <a href="https://incsso.income.com.sg/login/login.jsp?TYPE=33554432&REALMOID=06-921a7cf0-d1ca-4124-aed2-a80058c5a1df&GUID=&SMAUTHREASON=0&METHOD=GET&SMAGENTNAME=mpGg9VyWTnsLkKGFQy0dzGSiVD4R1XDkayfh2cmXYMiVHlowlTpLNmtDSocrx8r3&TARGET=-SM-http%3a%2f%2fincsso%2eincome%2ecom%2esg%2flogin%2findex%2ejsp"
                      target="_blank" rel="noopener">Income GI - Easy Portal</a>
                  </li>
                  <li>
                    <a href="https://online.libertyinsurance.com.sg/Portal/login" target="_blank" rel="noopener">Liberty
                      OneLiberty</a>
                  </li>
                  <li>
                    <a href="https://www.etiqa.com.sg/iConnect/Agent/Login" target="_blank" rel="noopener">eTiQa
                      iConnect</a>
                  </li>
                  <li>
                    <a href="https://azssgpb2c.b2clogin.com/azssgpb2c.onmicrosoft.com/B2C_1_signin/oauth2/v2.0/authorize?client_id=14a15f7f-3f66-4f38-b04e-7b86f96d8e24&redirect_uri=https%3A%2F%2Fshop.directasia.com%2Fagent%2Fpostlogin/&scope=https%3A%2F%2Fazssgpb2c.onmicrosoft.com%2Fagency%2Fall.readwrite&response_type=code&state=UVuX4njKa1aDRSum2MC5JywisXdL9X&code_challenge=ocYCWfMwcSjWZok91g7EAZsKLdqPI7Nn_qoUWIdHHM4&code_challenge_method=S256"
                      target="_blank" rel="noopener">Direct Asia</a>
                  </li>
                  <li>
                    <a href="https://ibiz.cntaiping.sg/#/page/login" target="_blank" rel="noopener">China Taiping Gi</a>
                  </li>
                  <li>
                    <a href="https://www.msig.com.sg/" target="_blank" rel="noopener">MSIG mConnect</a>
                  </li>
                  <li>
                    <a href="https://internet.eqinsurance.com.sg/eqwap/plogin/" target="_blank" rel="noopener">EQ
                      Insurance E-Portal</a>
                  </li>
                  <li>
                    <a href="https://www-6.aig.com/apaclogin/login/apac/jsp/apac_phome_en_sp_SG.jsp?state=NzkxNzQwNzR8MzM1NTQ0MzM&TYPE=33554433&REALMOID=06-000c5345-0cb8-10e9-bf08-0af90a570000&GUID=&SMAUTHREASON=0&METHOD=GET&SMAGENTNAME=-SM-K8FAx13GXuQUPrBbBv0hx2IjI2eOk2fhs0BUIPMeUVBe%2bvEWOVtuvUO3e667ZOW3&TARGET=-SM-HTTPS%3a%2f%2fwww--6%2eaig%2ecom%2fwps%2fmyportal%2fapac%2fprivate%3fapp%3d2fa_sg"
                      target="_blank" rel="noopener">AIG myAIG Login</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-pias-layout>